import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { useTranslation } from 'react-i18next';
import { SunIcon, MoonIcon } from '@heroicons/react/24/outline';

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className="h-9 w-9 flex items-center justify-center rounded-full glass-panel transition-colors hover:opacity-80"
      title={isDark ? t('theme.lightMode') : t('theme.darkMode')}
      aria-label={isDark ? t('theme.lightMode') : t('theme.darkMode')}
    >
      {isDark ? (
        <SunIcon className="h-[18px] w-[18px]" style={{ color: 'var(--fg)' }} />
      ) : (
        <MoonIcon className="h-[18px] w-[18px]" style={{ color: 'var(--fg)' }} />
      )}
    </button>
  );
}
